import { useEffect, useLayoutEffect, useRef } from 'react';

// Scale the whole display (rem-based) so everything fits the screen without scrolling
export const useAutoFit = (deps) => {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const root = document.documentElement;
    const fit = () => {
      const el = ref.current;
      if (!el) return;
      let lo = 6, hi = Math.max(16, Math.min(28, window.innerWidth / 60));
      for (let k = 0; k < 10; k += 1) {
        const mid = (lo + hi) / 2;
        root.style.fontSize = `${mid}px`;
        if (el.scrollHeight <= window.innerHeight) lo = mid; else hi = mid;
      }
      root.style.fontSize = `${lo}px`;
    };
    fit();
    window.addEventListener('resize', fit);
    window.addEventListener('orientationchange', fit);
    return () => { window.removeEventListener('resize', fit); window.removeEventListener('orientationchange', fit); };
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => () => { document.documentElement.style.fontSize = ''; }, []);
  return ref;
};

export const isStandalone = () => window.navigator.standalone === true || window.matchMedia?.('(display-mode: standalone)').matches;

export const DEPT_PALETTE = ['#f43f5e', '#f59e0b', '#22c55e', '#3b82f6', '#a855f7', '#ec4899', '#14b8a6', '#eab308', '#f97316', '#06b6d4', '#84cc16', '#8b5cf6'];
export const deptColor = (name, overrides = {}) => {
  if (overrides[name]) return overrides[name];
  let h = 0;
  for (let i = 0; i < name.length; i += 1) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return DEPT_PALETTE[h % DEPT_PALETTE.length];
};

export const groupByDept = (staff) => {
  const map = {};
  staff.forEach((s, i) => { const k = s.department || 'Other'; (map[k] = map[k] || []).push({ ...s, i }); });
  return Object.entries(map).sort(([a], [b]) => (a === 'Other') - (b === 'Other') || a.localeCompare(b));
};

const setMeta = (sel, create, attrs) => {
  let el = document.head.querySelector(sel);
  if (!el) { el = document.createElement(create); document.head.appendChild(el); }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

// Point "Add to Home Screen" at this display instead of the employee portal
export const useHomeScreenMeta = (token) => {
  useEffect(() => {
    document.title = 'Clock-in Live';
    setMeta('link[rel="manifest"]', 'link', { rel: 'manifest', href: `${process.env.REACT_APP_BACKEND_URL}/api/clock/public/display/${token}/manifest` });
    setMeta('meta[name="apple-mobile-web-app-title"]', 'meta', { name: 'apple-mobile-web-app-title', content: 'Clock-in Live' });
    setMeta('meta[name="apple-mobile-web-app-capable"]', 'meta', { name: 'apple-mobile-web-app-capable', content: 'yes' });
    setMeta('meta[name="apple-mobile-web-app-status-bar-style"]', 'meta', { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' });
    setMeta('meta[name="theme-color"]', 'meta', { name: 'theme-color', content: '#050b24' });
  }, [token]);
};
